module.exports = __webpack_public_path__ + "static/media/數位外交行動計畫.aa35407b.jpg";